import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.string.trim";
import "core-js/modules/web.dom-collections.for-each";
import _classCallCheck from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/bakirovsultanbek/Desktop/CBI/discuss-front/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/* global DOMParser */

/**
 * @module ui/icon/iconview
 */
import View from '../view';
import '../../theme/components/icon/icon.css';
/**
 * The icon view class.
 *
 * @extends module:ui/view~View
 */

var IconView = /*#__PURE__*/function (_View) {
  _inherits(IconView, _View);

  var _super = _createSuper(IconView);

  /**
   * @inheritDoc
   */
  function IconView() {
    var _this;

    _classCallCheck(this, IconView);

    _this = _super.call(this);
    var bind = _this.bindTemplate;
    /**
     * The SVG source of the icon.
     *
     * @observable
     * @member {String} #content
     */

    _this.set('content', '');
    /**
     * This attribute specifies the boundaries to which the
     * icon content should stretch.
     *
     * @observable
     * @default '0 0 20 20'
     * @member {String} #viewBox
     */


    _this.set('viewBox', '0 0 20 20');
    /**
     * The fill color of the child `path.ck-icon__fill`.
     *
     * @observable
     * @default ''
     * @member {String} #fillColor
     */


    _this.set('fillColor', '');

    _this.setTemplate({
      tag: 'svg',
      ns: 'http://www.w3.org/2000/svg',
      attributes: {
        class: ['ck', 'ck-icon'],
        viewBox: bind.to('viewBox')
      }
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(IconView, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      _get(_getPrototypeOf(IconView.prototype), "render", this).call(this);

      this._updateXMLContent();

      this._colorFillPaths(); // This is a hack for lack of innerHTML binding.
      // See: https://github.com/ckeditor/ckeditor5-ui/issues/99.


      this.on('change:content', function () {
        _this2._updateXMLContent();

        _this2._colorFillPaths();
      });
      this.on('change:fillColor', function () {
        _this2._colorFillPaths();
      });
    }
    /**
     * Updates the {@link #element} with the value of {@link #content}.
     *
     * @private
     */

  }, {
    key: "_updateXMLContent",
    value: function _updateXMLContent() {
      if (this.content) {
        var parsed = new DOMParser().parseFromString(this.content.trim(), 'image/svg+xml');
        var svg = parsed.querySelector('svg');
        var viewBox = svg.getAttribute('viewBox');

        if (viewBox) {
          this.viewBox = viewBox;
        }

        this.element.innerHTML = '';

        while (svg.childNodes.length > 0) {
          this.element.appendChild(svg.childNodes[0]);
        }
      }
    }
    /**
     * Fills all child `path.ck-icon__fill` with the `#fillColor`.
     *
     * @private
     */

  }, {
    key: "_colorFillPaths",
    value: function _colorFillPaths() {
      var _this3 = this;

      if (this.fillColor) {
        this.element.querySelectorAll('.ck-icon__fill').forEach(function (path) {
          path.style.fill = _this3.fillColor;
        });
      }
    }
  }]);

  return IconView;
}(View);

export { IconView as default };